import { render, staticRenderFns } from "./CompanionOptionsList.vue?vue&type=template&id=21ee7787&scoped=true&"
import script from "./CompanionOptionsList.vue?vue&type=script&lang=js&"
export * from "./CompanionOptionsList.vue?vue&type=script&lang=js&"
import style0 from "./CompanionOptionsList.vue?vue&type=style&index=0&id=21ee7787&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee7787",
  null
  
)

export default component.exports